import Alert from './Alert'
import Checkbox from './Inputs/Checkbox.vue'
import IconCheckbox from './Inputs/IconCheckbox.vue'
import Radio from './Inputs/Radio.vue'
import FormGroupInput from './Inputs/formGroupInput.vue'
import Switch from './Switch.vue'
import Badge from './Badge'
import Progress from './Progress.vue'
import Button from './Button.vue'

import DropDown from './Dropdown.vue'
import Table from './Table.vue'

import Card from './Cards/Card.vue'
import StatsCard from './Cards/StatsCard.vue'
import Navbar from './Navbar/Navbar';
import NavLink from './Navbar/NavLink';
import NavbarToggleButton from './Navbar/NavbarToggleButton';
import TabPane from './Tabs/Tab.vue'
import Tabs from './Tabs/Tabs.vue'
import Collapse from './Collapse/Collapse.vue'
import CollapseItem from './Collapse/CollapseItem.vue'
import Modal from './Modal.vue'
import Parallax from './Parallax.vue'
import Slider from './Slider.vue'

import Pagination from './Pagination.vue'

import Comment from './Comments/Comment'
import InfoSection from './InfoSection'

export {
    Alert,
    Checkbox,
    IconCheckbox,
    Switch,
    Badge,
    Progress,
    Pagination,
    Radio,
    FormGroupInput,
    Card,
    StatsCard,
    Table,
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    TabPane,
    Tabs,
    Modal,
    Parallax,
    Slider,
    Button,
    Collapse,
    CollapseItem,
    Comment,
    InfoSection
}